import axios from '@/utils/axios'

export default async function GetSlugs() {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/products/get-product-slugs',
  )
  return data
}

export async function GetNotebookSlugs() {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/products/get-notebook-slugs',
  )
  return data
}
